import React from "react";
import FormaPagoPymes from "./FormaPagoPymes";

/**
 * Container para la página de Forma de Pago PYMES.
 * Funcional component — no necesita state ni dispatch propios,
 * ya que FormaPagoPymes maneja su propia conexión a Redux.
 */
const ContainerFormaPagoPymes = () => {
    return (
        <main className="cr-app bg-light">
            <div className="cr-content container-fluid">
                <div className="container-body-spaces">
                    <FormaPagoPymes />
                </div>
            </div>
        </main>
    );
};

export default ContainerFormaPagoPymes;
